import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Modal from './modal';
import './DesignerScreen.css';
import { useNavigate } from 'react-router-dom';
import { Header } from '../Header';
import { local_url } from '../Const';

export const DesignerScreen = () => {
  const [customerName, setCustomerName] = useState('');
  const [customerId, setCustomerId] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [area, setArea] = useState('L111'); // Default area selection
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCustomerData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${local_url}/api/Customer/${area}/FS/`);
        const data = response.data.branches;
        const formattedCustomers = data.map(branch => ({
          id: branch.customerCode,
          name: branch.customerName,
        }));
        setCustomers(formattedCustomers);
      } catch (error) {
        console.error('Error fetching customer data:', error);
        setError('Failed to fetch customer data. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchCustomerData();
  }, [area]); // Re-fetch data when area changes

  const handleSelectCustomer = (id, name) => {
    setCustomerName(name);
    setCustomerId(id);
    setIsModalOpen(false);
  };

  const handleSubmit = () => {
    console.log(`Submitting customer: ${customerName} with ID: ${customerId}, Area: ${area}`);
    navigate('/ledgerScreen', { state: { customerName, customerId, area } });
  };

  return (
    <>
      <div className="designer-screen">
        <Header />
      </div>
      <div className="designer-screen-container">
        <h1>Customer Ledger</h1>

        {loading && <p className="loading">Loading customers...</p>}
        {error && <p className="error">{error}</p>}


        <div className="customer-input">
          <label>
            Customer Name:
            <input
              type="text"
              value={customerName}
              onChange={(e) => setCustomerName(e.target.value)}
              placeholder="Enter or select customer name"
              aria-label="Customer Name"
            />
          </label>

          <label className="area-picker-label">Choose Location :  
            <select className="area-picker" value={area} onChange={(e) => setArea(e.target.value)}>
              <option value="L111">L111</option>
              <option value="L135">L135</option>
            </select>
          </label>

          <button onClick={() => setIsModalOpen(true)} disabled={loading}>
            Select Customer
          </button>
        </div>
        
        <button onClick={handleSubmit} disabled={!customerName}>Submit</button>

        <Modal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onSelect={handleSelectCustomer}
          customers={customers}
        />
      </div>

      <style>
        {`
          .area-picker-label {
            font-weight: bold;
            margin-right: 10px;
          }

          .area-picker {
            padding: 8px;
            border: 1px solid #ccc;
            border-radius: 5px;
            background-color: #f9f9f9;
            font-size: 16px;
            cursor: pointer;
            transition: all 0.3s ease;
          }

          .area-picker:hover {
            background-color: #e6e6e6;
          }

          .area-picker:focus {
            border-color: #007bff;
            outline: none;
          }
        `}
      </style>
    </>
  );
};

export default DesignerScreen;
